import React from "react";
import { Helmet } from "react-helmet";

function App() {
  return (
    <div className="application">
      <Helmet>
        <title>Keem Fan</title>
        <meta name="description" content="Fan page for the Keem" />
        <meta name="robots" content="index, follow" />
      </Helmet>
    </div>
  );
}

export default App;